import { Component, Output, Input, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//Models
import { User } from '../../../shared/models/user.model';
import { UserStates } from '../../../shared/models/userstate.model';
//Servicios
import { UserService } from '../../../shared/_services/user.service';
import { UtilitiesService } from '../../../shared/_services/utilities.service';
import { Router } from '@angular/router';
import { trigger, style, animate, transition, state } from '@angular/animations';

@Component({
  selector: 'app-summary-user',
  templateUrl: './summary-user.component.html',
  styleUrls: ['./summary-user.component.css'],
  animations: [
    trigger('EnterLeave', [
      state('flyin', style({
        opacity: 1,
        transform: 'translateX(0%)'
      })),
      transition(':enter', [
        style({
          opacity: 0.2,
          transform: 'translateX(-100%)'
        }),
        animate('0.3s 300ms ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({ transform: 'translateX(100%)'})) 
      ])
    ])
  ]
})

export class SummaryUserComponent{

   

  @Input() Usuario: User;
  @Output() collapse: EventEmitter<boolean> = new EventEmitter();

  UsuarioSeleccionado: User;
  ListEstados: UserStates[];
  constructor(  
    private _ultilitesService: UtilitiesService,
    private router: Router
  ) {
    this.ListEstados =  this._ultilitesService.currentListUserstates;
  }


  onEdit(usuario: User): void {
    this.UsuarioSeleccionado = usuario;
    this.scrollTop();
    this.collapse.emit(false);
    this.router.navigate(['/admin-users/detail', usuario.idUser, 1])
  }

  onSelect(usuario: User): void {
    this.scrollTop();
    this.collapse.emit(false);
    this.router.navigate(['/admin-users/detail', usuario.idUser, 0 ])
  }



  //scroll
  scrollTop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }
}
